import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function assigned() {
  const { data } = await axios.get(routes.assignedOutlet, AXIOS_DEFAULT_CONFIG);
  return data;
}
